import { Box, chakra, Flex } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import useNavItems, { isGroupItem } from 'lib/hooks/useNavItems';
import RewardsButton from 'ui/rewards/RewardsButton';
import { CONTENT_MAX_WIDTH } from 'ui/shared/layout/utils';
import NetworkLogo from 'ui/snippets/networkMenu/NetworkLogo';
import UserProfileDesktop from 'ui/snippets/user/profile/UserProfileDesktop';
import UserWalletDesktop from 'ui/snippets/user/wallet/UserWalletDesktop';

import HeaderGasPrice from '../../header/HeaderGasPrice';
import NavLink from './NavLink';
import NavLinkGroup from './NavLinkGroup';

const NavigationDesktop = () => {
  const { mainNavItems } = useNavItems();

  return (
    <Box
      as="header"
      bgColor="white"
      borderColor="border.divider"
      borderBottomWidth="1px"
      boxShadow="0 4px 18px rgba(25, 76, 125, 0.06)"
      position="relative"
      zIndex="sticky"
    >
      <Flex
        display={{ base: 'none', lg: 'flex' }}
        alignItems="center"
        px={ 6 }
        minH="72px"
        maxW={ `${ CONTENT_MAX_WIDTH }px` }
        m="0 auto"
      >
        <NetworkLogo isCollapsed={ false } minW="178px"/>
        <chakra.nav
          aria-label="ناوبری اصلی کاوشگر"
          marginInlineStart={ 4 }
        >
          <Flex as="ul" columnGap={ 1 } alignItems="center">
            { mainNavItems.map((item) => {
              if (isGroupItem(item)) {
                return <NavLinkGroup key={ item.text } item={ item }/>;
              } else {
                return <NavLink key={ item.text } item={ item } noIcon compact/>;
              }
            }) }
          </Flex>
        </chakra.nav>
        <Box flex="1"/>
        <Flex gap={ 2 }>
          { config.features.rewards.isEnabled && <RewardsButton size="sm"/> }
          {
            (config.features.account.isEnabled && <UserProfileDesktop buttonSize="sm"/>) ||
            (config.features.blockchainInteraction.isEnabled && <UserWalletDesktop buttonSize="sm"/>)
          }
        </Flex>
        <HeaderGasPrice/>
      </Flex>
    </Box>
  );
};

export default React.memo(NavigationDesktop);
